import React from 'react';
import { Box, Typography, CircularProgress, LinearProgress } from '@mui/material';

export const CircularScore = ({ score }) => {
    const color = score >= 80 ? 'success' : score >= 50 ? 'warning' : 'error';
    const displayScore = score ? Math.round(score) : 0;

    return (
        <Box sx={{ position: 'relative', display: 'inline-flex' }}>
            <CircularProgress variant="determinate" value={displayScore} color={color} size={45} thickness={4} />
            <Box sx={{ top: 0, left: 0, bottom: 0, right: 0, position: 'absolute', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Typography variant="caption" component="div" sx={{ fontWeight: 'bold', color: '#2c3e50' }}>
                    {displayScore}%
                </Typography>
            </Box>
        </Box>
    );
};

export const ScoreBar = ({ label, score }) => {
    const displayScore = score ? Math.round(score) : 0;
    const color = displayScore >= 80 ? '#20c997' : displayScore >= 50 ? '#ffc107' : '#dc3545';

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.8, gap: 1 }}>
            <Typography variant="caption" sx={{ width: 80, color: '#6c757d', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {label}
            </Typography>
            <LinearProgress
                variant="determinate"
                value={displayScore}
                sx={{ flex: 1, height: 6, borderRadius: 3, backgroundColor: '#e9ecef', '& .MuiLinearProgress-bar': { backgroundColor: color } }}
            />
            <Typography variant="caption" sx={{ width: 35, textAlign: 'right', color: color, fontWeight: 'bold' }}>
                {displayScore}%
            </Typography>
        </Box>
    );
};

export const SeniorityBar = ({ label, level, score }) => {
    const color = level === 'Confirmé' || score >= 80 ? '#20c997' : '#ffc107';
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, gap: 1 }}>
            <Typography variant="body2" sx={{ width: 120, color: '#495057' }}>{label}</Typography>
            <LinearProgress
                variant="determinate"
                value={score}
                sx={{ flex: 1, height: 6, borderRadius: 3, backgroundColor: '#e9ecef', '& .MuiLinearProgress-bar': { backgroundColor: color } }}
            />
            <Typography variant="caption" sx={{ width: 70, textAlign: 'right', color: color, fontWeight: 'bold' }}>{level}</Typography>
        </Box>
    );
};
